module.exports = __webpack_public_path__ + "static/media/hero.9e32cfa8.png";